import { createFileRoute } from "@tanstack/react-router";
import { Atom, HeartHandshake, RadioTower } from "lucide-react";
import { breadcrumbScript, seo } from "@/lib/seo";
import {
  CommunityMenuCard,
  CommunityPage,
  CreatorCard,
} from "@/components/community/community-ui";

const DESCRIPTION = "Learn about The Quantum Minds, join our official channels, and connect with the creator.";

export const Route = createFileRoute("/community/")({
  head: () => ({
    ...seo({ title: "Our Community — The Quantum Minds", description: DESCRIPTION, path: "/community" }),
    scripts: [
      breadcrumbScript([
        { name: "Home", path: "/" },
        { name: "Our Community", path: "/community" },
      ]),
    ],
  }),
  component: CommunityHub,
});

function CommunityHub() {
  return (
    <CommunityPage
      eyebrow="Community & Support"
      title="Our Community"
      description="About The Quantum Minds & the people behind it."
      backTo="/profile"
    >
      <nav aria-label="Community sections" className="space-y-3">
        <CommunityMenuCard
          to="/community/about"
          icon={Atom}
          title="The Quantum Minds"
          subtitle="Our platform, mission & vision"
          tone="primary"
        />
        <CommunityMenuCard
          to="/community/social"
          icon={RadioTower}
          title="Our Community"
          subtitle="Social channels, updates & announcements"
          tone="accent"
        />
        <CommunityMenuCard
          to="/community/owner"
          icon={HeartHandshake}
          title="Owner & Support"
          subtitle="Connect directly with the creator"
          tone="success"
        />
      </nav>
      <CreatorCard />
    </CommunityPage>
  );
}
